<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.frc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fcc {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.frcs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.cc {
  align-items: center;
  justify-content: center;
  display: flex;
}


</style>



// WEBPACK FOOTER //
// src/App.vue